import React, { useContext, useEffect, useState } from "react";
import "../../css/Commission.css";
import CryptoJS from "crypto-js";
import SidebarContext from "../sidebarcontext/SidebarContext";
import ReversePop from "../ReportPage/ReversePop";
import BankTransferContext from "../contextfolder/BankTransferContext/BankTransferContext";

const BankTransferTable = ({ searchTerm, componentRef }) => {
  const { reportList } = useContext(BankTransferContext);

  let sum = reportList.reduce(function (prev, current) {
    return prev + +current.amount;
  }, 0);

  if (reportList.length > 0) {
    return (
      <>
        <div className="table-responsive br-3">
          <table
            className="table table-bordereds text-nowrap mb-0"
            id="table-to-xls"
            ref={componentRef}
          >
            <thead>
              <tr className="tableHead">
                <td className="tc">S.N.</td>
                <td className="tc">TranID</td>
                <td className="tc">Date</td>
                <td className="tl">Username</td>
                <td className="tl">From (A/c No.)</td>
                <td className="tc">Amount</td>
                <td className="tl">Remarks</td>
                <td className="tl">Status</td>
              </tr>
            </thead>
            <tbody>
              {reportList
                .filter((val) => {
                  if (searchTerm === "") {
                    return val;
                  } else if (
                    val.senderAccountNum
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val;
                  }
                })
                .map((item, i) => (
                  <tr key={i}>
                    <td className="tc">{i + 1}</td>
                    <td className="tc">{item.tranID}</td>
                    <td className="tc">{item.txnDate}</td>
                    <td className="tl">{item.userName}</td>
                    <td className="tl">{item.destAccountNum}</td>
                    <td className="tc">{item.amount}</td>
                    <td className="tl">{item.remarks}</td>
                    <td className="tl">{item.status}</td>
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td style={{ borderRight: "1px solid transparent" }}></td>
                <td
                  style={{
                    borderRight: "1px solid transparent",
                    borderLeft: "1px solid transparent",
                  }}
                ></td>

                <th>Total</th>
                <td className="tc fw-bold">{sum}</td>
                <td
                  style={{
                    borderRight: "1px solid transparent",
                  }}
                ></td>
                <td
                  style={{
                    borderLeft: "1px solid transparent",
                  }}
                ></td>
                <td
                  style={{
                    borderLeft: "1px solid transparent",
                  }}
                ></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </>
    );
  } else {
    return (
      <div className="table-responsive br-3">
        <table className="table table-bordereds text-nowrap mb-0">
          <thead>
            <tr className="tableHead">
              <td className="tc">S.N.</td>
              <td className="tc">TranID</td>
              <td className="tc">Date</td>
              <td className="tl">Username</td>
              <td className="tl">From (A/c No.)</td>
              <td className="tc">Amount</td>
              <td className="tl">Remarks</td>
              <td className="tl">Status</td>
            </tr>
          </thead>
        </table>
        <div className="text-center mt-4">
          <p>No Data Found</p>
        </div>
      </div>
    );
  }
};

export default BankTransferTable;
